import { AuthContext } from '@shared/context/AuthContext';
import APIService from '@shared/services/api';
import React, { useState, useContext, useEffect } from 'react';

export function Dashboard() {
    const { setLoader } = useContext(AuthContext);

    const [demandCount, setDemandCount] = useState(0);
    const [bidCount, setBidCount] = useState(0);
    const [userCount, setUserCount] = useState(0);
    const [showSnipper, setshowSnipper] = useState(false);

    const getCount = async () => {
        try {
            setshowSnipper(true);
            // const { data: demandC } = await APIService.getAll(`dashboard/demand`, true, false);
            // const { data: bidC } = await APIService.getAll(`dashboard/bid`, true, false);
            // const { data: userC } = await APIService.getAll(`dashboard/user`, true, false);
            const {data} = await APIService.getAll(`dashboard/AllCounts`, true, false);
            const { demand, bids, users } = data.data;
            setDemandCount(demand);
            setBidCount(bids);
            setUserCount(users);
            setshowSnipper(false);
        } catch (err) {
            setLoader(false);
        }
    };

    useEffect(() => {
        getCount();
    }, []);

    return (
        <div className="container dash-container">
            <div className="dash_bread_box">
                <ul>
                    <li>Home</li>
                </ul>
            </div>
            <div className="quick_info_cover">
                <div className="row">
                    <div className="col-sm-4">
                        <div className="quick_info_item demands_info_box">
                            <div className="text_box">
                                <h4>No. of Demands Today</h4>
                                {showSnipper ? (
                                    <img src="assets/images/spinner.gif" height={25} width={25} />
                                ) : (
                                    <h3>{demandCount}</h3>
                                )}
                            </div>
                            <img className="info_img img-fluid" src="assets/images/demands_info.svg" />
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <div className="quick_info_item bids_info_box">
                            <div className="text_box">
                                <h4>No. of Bids Today</h4>
                                {showSnipper ? (
                                    <img src="assets/images/spinner.gif" height={25} width={25} />
                                ) : (
                                    <h3>{bidCount}</h3>
                                )}
                            </div>
                            <img className="info_img img-fluid" src="assets/images/bids_info.svg" />
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <div className="quick_info_item  vendors_info_box">
                            <div className="text_box">
                                <h4>No. of Registered Vendors</h4>
                                {showSnipper ? (
                                    <img src="assets/images/spinner.gif" height={25} width={25} />
                                ) : (
                                    <h3>{userCount}</h3>
                                )}
                            </div>
                            <img className="info_img img-fluid" src="assets/images/vendors_info.svg" />
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="list_accordion_box">
                <div className="accordion accordion-flush" id="accordionExample">
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="headingOne">
                            <button
                                className="accordion-button"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseOne"
                                aria-expanded="true"
                                aria-controls="collapseOne"
                            >
                                Notifications
                            </button>
                        </h2>
                        <div
                            id="collapseOne"
                            className="accordion-collapse collapse show"
                            aria-labelledby="headingOne"
                            data-bs-parent="#accordionExample"
                        >
                            <div className="accordion-body">
                                <ul className="list_box">
                                    <li className="new_notification_box">
                                        <a href="#">
                                            <span className="badge custom_badge">New</span> Ramesh has placed a bid on{' '}
                                            <b>Bhilwara to Jaipur</b> Demand.
                                            <span className="time_box">Just now</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">
                                            Ramesh has placed a bid on <b>Bhilwara to Jaipur</b> Demand.
                                            <span className="time_box">Just now</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">
                                            Ramesh has placed a bid on <b>Bhilwara to Jaipur</b> Demand.
                                            <span className="time_box">Just now</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">
                                            Ramesh has placed a bid on <b>Bhilwara to Jaipur</b> Demand.
                                            <span className="time_box">Just now</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">
                                            Ramesh has placed a bid on <b>Bhilwara to Jaipur</b> Demand.
                                            <span className="time_box">Just now</span>
                                        </a>
                                    </li>
                                </ul>
                                <a className="btn custom_btn full_btn" href="#">
                                    View All
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
        </div>
    );
}
